<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store.js';
import { useAlert } from 'dashboard/composables';

import CardItem from 'dashboard/routes/dashboard/wgptBoards/item/list/card/Index.vue';
import Spinner from 'next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const store = useStore();

const allLabels = useMapGetter('labels/getLabels');
const allAgents = useMapGetter('agents/getAgents');
const cards = useMapGetter('wgptContactCards/get');
const uiFlags = useMapGetter('wgptContactCards/getUIFlags');

const contactId = computed(() => Number(route.params.contactId));

const fetchContactCards = async () => {
  try {
    await store.dispatch('wgptContactCards/get', contactId.value);
  } catch (error) {
    useAlert(error.message);
  }
};

const fetchAgents = () => {
  if (allAgents.value.length) return;
  store.dispatch('agents/get');
};

const fetchLabels = () => {
  if (allLabels.value.length) return;
  store.dispatch('labels/get');
};

onMounted(() => {
  fetchContactCards();
  fetchAgents();
  fetchLabels();
});
</script>

<template>
  <div class="px-4 py-6">
    <div
      v-if="uiFlags.isFetching"
      class="flex items-center justify-center text-n-slate-11"
    >
      <Spinner />
    </div>
    <div v-else-if="cards.length > 0" class="flex flex-col gap-6">
      <div>
        <router-link
          v-for="card in cards"
          :key="card.id"
          :to="{
            name: 'board_item',
            params: { boardId: card.board_id },
            query: { selectedCard: card.id },
          }"
          target="_blank"
        >
          <CardItem
            :card="card"
            :labels="allLabels"
            :agents="allAgents"
            is-neutral
            class="card item first:mb-[2px] last:mb-[2px]"
          />
        </router-link>
      </div>
    </div>
    <p v-else class="px-6 py-10 text-sm leading-6 text-center text-n-slate-11">
      {{ t('WGPT_BOARDS.CONTACTS_LAYOUT.SIDEBAR.CARDS.EMPTY_STATE') }}
    </p>
  </div>
</template>
